import { Col, QRCode, Row, Typography } from 'antd';
import React from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { useParams } from 'react-router-dom';
import { Loading } from '../../../../../base-react/components/Loading';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
import { getAssetUrl } from '../../../../../base-react/scripts/cdn';
const { Title, Text } = Typography;
export const PrintQrCode = () => {
    const { competition_id } = useParams();
    const [inputCompetition, event, , loadingCompetition] = useCompetition(competition_id);
    const origin = window.location.origin;
    var qrCodeLocation = `${origin}/public/event/${event === null || event === void 0 ? void 0 : event.competition_id}/comp/${competition_id}/registration`;
    if (loadingCompetition) {
        return React.createElement(Loading, null);
    }
    const pageStyle = {
        position: 'relative',
        minHeight: '100vh',
        margin: 0,
        pageBreakAfter: 'avoid',
        overflow: 'hidden',
    };
    const imageStyle = {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: -1,
    };
    const contentWrapperStyle = {
        position: 'relative',
        margin: 48,
        padding: 32,
        minHeight: 'calc(100vh - 96px)',
        backgroundColor: 'white',
        borderRadius: 12,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    };
    const contentStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 40,
        height: '100%',
        textAlign: 'center',
        padding: '0 32px',
        flex: 1,
    };
    const hintTextStyle = {
        margin: 0,
        textTransform: 'uppercase',
    };
    return (React.createElement("div", { style: pageStyle },
        React.createElement("img", { style: imageStyle, src: getAssetUrl(require('../../../../../screens-react/images/background.jpg')) }),
        React.createElement("div", { style: contentWrapperStyle },
            React.createElement(PrintHeader, { event: event, competition: event }),
            React.createElement("div", { style: contentStyle },
                React.createElement(QRCode, { size: 420, iconSize: 96, value: qrCodeLocation, icon: getAssetUrl(require('../../../../../base-react/images/favicon-128.png')) }),
                React.createElement(Title, { style: hintTextStyle }, _T('registration.qrcode-hint').toUpperCase())))));
};
const PrintHeader = (props) => {
    const { event, competition } = props;
    return (React.createElement(Row, { wrap: false, justify: 'space-between', style: { width: '100%', height: 100 } },
        React.createElement(Col, { flex: '100px' },
            React.createElement(Typography, null,
                React.createElement(Text, { strong: true }, "Vote4"),
                "Dance")),
        React.createElement(Col, { flex: 'auto' },
            React.createElement(Typography, { style: { textAlign: 'center' } },
                React.createElement(Title, { style: { margin: 0 } }, competition === null || competition === void 0 ? void 0 : competition.competition_name),
                (competition === null || competition === void 0 ? void 0 : competition.competition_parent_id) &&
                    React.createElement(Title, { level: 2, type: "secondary", style: { margin: 0 } }, event === null || event === void 0 ? void 0 : event.competition_name),
                React.createElement(Text, null, event === null || event === void 0 ? void 0 : event.competition_organizer))),
        React.createElement(Col, { flex: '100px' },
            React.createElement(Typography, { style: { textAlign: 'right' } },
                React.createElement(Text, null, competition === null || competition === void 0 ? void 0 : competition.competition_date)))));
};
